import { z } from "zod"

export enum CustomMessageType {
  BIKE_DONE_REMINDER = "BIKE_DONE_REMINDER",
  RECEPTION_CONFIRMATION = "RECEPTION_CONFIRMATION",
  SERVICE_DONE = "SERVICE_DONE",
  /** Free-standing template, not tied to any lifecycle message. */
  CUSTOM = "CUSTOM",
}

export interface CustomMessageVariant {
  id: string
  title: string
  message: string
  messageType: CustomMessageType
  createdAt: Date
  updatedAt: Date
}

export interface CreateCustomMessageVariant {
  title: string
  message: string
  messageType: CustomMessageType
}

export interface UpdateCustomMessageVariant {
  title?: string
  message?: string
}

export const CreateCustomMessageVariantSchema = z.object({
  title: z.string().min(1).max(100),
  message: z.string().min(1),
  messageType: z.nativeEnum(CustomMessageType),
})

export const UpdateCustomMessageVariantSchema = z.object({
  title: z.string().min(1).max(100).optional(),
  message: z.string().min(1).optional(),
})
